export const companiesKeys = {
	all: ['crm', 'companies'],
	list: (filters) => ['crm', 'companies', 'list', filters],
	detail: (companyId) => ['crm', 'companies', 'detail', companyId],
	trash: (filters) => ['crm', 'companies', 'trash', filters],
};

export const companiesMutationKeys = {
	create: ['crm', 'companies', 'create'],
	softDelete: ['crm', 'companies', 'softDelete'],
	restore: ['crm', 'companies', 'restore'],
	bulkDelete: ['crm', 'companies', 'bulkDelete'],
	bulkRestore: ['crm', 'companies', 'bulkRestore'],
};
